import { Component, OnInit, Input, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from './auth.service';
import { AppService } from '../app/app.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthComponent implements OnInit {

	form = new FormGroup({
		login: new FormControl('', [Validators.required]),
		password: new FormControl('', [Validators.required])
	});
	
	submitting = false;
	hide = true;

	set error(error: boolean) {
		if (error) {
			this._snack.open('Invalid login or password');
		}
		this.submitting = false;
	};

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: {login: string},
		private _ref: MatDialogRef<AuthComponent>,
		private _auth: AuthService,
		private _snack: MatSnackBar,
	) { }

	ngOnInit() {
		
		const d = this.data,
			f = this.form;

		if (d) {
			f.get('login').setValue(d.login);
		}
	}

	submit() {

		const v = this.form.value;

		this.error = false;
		this.submitting = true;

		this._auth
			.login(this.form.value)
			.subscribe(
				() => {
					this.error = false;
					this._ref.close(true)
				},
				err => this.error = true
			);
	}

}
